


































import moment from 'moment';
import { Component, Prop } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { formatter } from '../app.config';
import { dataLayer } from '../globals';
import { EventBus } from '../helpers/bus';
import Calculator from '../helpers/calculator';
import { IFlight, ITour } from '../store/models';
import BaseComponent from './Base';

@Component
export default class PricesCalendar extends BaseComponent {
    @Prop({ type: String, default: '%s' }) protected readonly format: string;

    @Prop({ type: Number }) protected readonly sid: ITour['sid'];

    @Prop({ type: String, default: 'Travel date calendar in the bottom of a tour page' }) protected readonly gtmCategory: string;

    @State('flights', { namespace: 'orm' }) protected readonly storedFlights: IFlight[];

    protected selectedDate: number | null = null;

    protected onChangeMonth(event): void {
        dataLayer.push({
            eventAction: 'Change Month',
            eventCategory: this.gtmCategory,
            event: 'pricesCalendar:changeMonth',
        });
    }

    protected forwardToMinPriceDate() {
        let timestamp = new Date().getTime();
        const minPrice = this.minAdultPrice;
        for (const [dateKey, pack] of Object.entries(this.flightPrices)) {
            if (pack.price === minPrice) {
                timestamp = +dateKey;
                break;
            }
        }

        const calendar: any = this.$refs.calendar;
        const date = new Date(timestamp);
        this.selectedDate = date.getTime();

        calendar.fromPage_ = {
            month: date.getMonth() + 1,
            year: date.getFullYear(),
        };
    }

    protected get flight(): IFlight | null {
        return this.storedFlights.find(({ tourSid }) => tourSid === this.sid) || null;
    }

    protected get minAdultPrice(): string {
        return this.formatPrice(this.flight ? Calculator.minPrice(this.flight.prices.map(({ adultPrice }) => adultPrice)) : null);
    }

    protected get buttonLabelMinAdultPrice() {
        return this.t('From %s pp').replace('%s', this.minAdultPrice);
    }

    protected get minChildPrice(): string {
        return this.formatPrice(this.flight ? Calculator.minPrice(this.flight.prices.map(({ childPrice }) => childPrice)) : null);
    }

    protected get buttonLabelMinChildPrice() {
        return this.t('Children under 12 years from %s').replace('%s', this.minChildPrice);
    }

    protected get flightPrices(): { [date: number]: { price: string, disabled: boolean, dfPrice: string } } {
        const prices: { [date: number]: { price: string, disabled: boolean, dfPrice: string } } = {};
        if (!this.flight) {
            return prices;
        }

        this.flight.prices.forEach(({ date, adultPrice, adultPriceWithDirectFlight }) => {
            const disabled = Calculator.isSoldOut(adultPrice);
            const dt = moment(date, 'YYYY-MM-DD').startOf('day').toDate().valueOf();
            let price: any = null;
            let dfPrice: any = null;
            switch (adultPrice) {
                case Calculator.SOLD_OUT:
                    price = this.t('Soldout');
                    break;
                case Calculator.ON_REQUEST:
                    price = this.t('On request');
                    break;
                default:
                    price = this.format.replace('%s', formatter.asCurrency(adultPrice));
                    break;
            }
            switch (adultPriceWithDirectFlight) {
                case Calculator.SOLD_OUT:
                    dfPrice = this.t('Soldout');
                    break;
                case Calculator.ON_REQUEST:
                    dfPrice = this.t('On request');
                    break;
                case '0':
                    break;
                default:
                    if (adultPriceWithDirectFlight) {
                        dfPrice = this.format.replace('%s', formatter.asCurrency(adultPriceWithDirectFlight));
                    }
                    break;
            }
            prices[dt] = { price, disabled, dfPrice };
        });

        return prices;
    }

    protected formatPrice(price): string {
        return this.format.replace('%s', formatter.asCurrency(price));
    }

    protected get minDate(): Date | null {
        if (Object.keys(this.flightPrices).length === 0) {
            return null;
        }
        return new Date(Math.min.apply(null, Object.keys(this.flightPrices)));
    }

    protected get maxDate(): Date | null {
        if (Object.keys(this.flightPrices).length === 0) {
            return null;
        }
        return new Date(Math.max.apply(null, Object.keys(this.flightPrices)));
    }

    protected get fromPage(): { month: number, year: number } {
        const date = this.minDate || new Date();

        return {
            month: date.getMonth(),
            year: date.getFullYear(),
        };
    }

    protected get themeStyles(): any {
        return {
            wrapper: {
                border: '0',
                padding: '10px',
                width: '100%',
            },
            header: {
                padding: '15px 10px 25px 10px',
            },
            headerTitle: {
                fontSize: '18px',
                fontWeight: '700',
                letterSpacing: '.1em',
                textTransform: 'uppercase',
            },
            headerArrows: {
                fontSize: '18px',
                fontWeight: '100',
            },
            headerHorizontalDivider: {
                display: 'none',
            },
            weekdays: {
                color: '#000',
                fontWeight: '400',
                fontSize: '14px',
                padding: '20px 5px 10px 5px',
                textTransform: 'capitalize',
                letterSpacing: '.01em',
            },
        };
    }

    protected selectDay(dateTime: number, disabled: boolean): void {
        if (disabled) {
            return;
        }
        if (this.selectedDate === dateTime) {
            this.selectedDate = null;
            EventBus.$emit('enquireForm:dateSet', null);
        } else {
            this.selectedDate = dateTime;
            EventBus.$emit('enquireForm:dateSet', dateTime);
        }
        dataLayer.push({
            eventAction: 'Select Day',
            eventCategory: this.gtmCategory,
            event: 'pricesCalendar:selectDay',
        });
    }

    protected directFlightTooltip(dfPrice: string): any {
        return {
            content: this.t('Direct flight') + '<br>' + dfPrice,
            classes: 'c-tooltip--info',
        };
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PricesCalendar.vue